import { render } from "./ListeCleTypeNotification.vue?vue&type=template&id=20a76cc2&ts=true"
import script from "./ListeCleTypeNotification.vue?vue&type=script&lang=ts"
export * from "./ListeCleTypeNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__